import styled from "styled-components";

const paymentIconWidth = 36;

export const Icon = styled.div(({ theme }) => ({
    height: `${paymentIconWidth}px`,
    display: "flex",
    width: `${paymentIconWidth}px`,
    textAlign: "left",
    alignSelf: "flex-start",
    alignItems: "center",
    borderRadius: theme.spacing.xSmall,
    border: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
}));

export const IconImg = styled.img(({ theme }) => ({
    maxHeight: theme.spacing.xxLarge,
    width: "auto",
    maxWidth: "100%",
    margin: "auto",
}));
